// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListEpmMasterRoleTypesQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ListEpmMasterRoleTypesQuery = { __typename?: 'Query' } & {
  listEpmMasterRoleTypes: { __typename?: 'ListEpmMasterRoleTypes' } & Pick<
    Types.ListEpmMasterRoleTypes,
    'totalCount'
  > & {
      items: Array<
        { __typename?: 'EpmMasterRoleType' } & Pick<
          Types.EpmMasterRoleType,
          'id' | 'name' | 'enabled' | 'sortOrder' | 'createdAt' | 'updatedAt'
        > & {
            usageStats: { __typename?: 'EpmMasterSimpleUsageStats' } & Pick<
              Types.EpmMasterSimpleUsageStats,
              'employeeAllocationCount'
            >;
          }
      >;
    };
};

export const ListEpmMasterRoleTypesDocument = /*#__PURE__*/ gql`
    query listEpmMasterRoleTypes($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $keyword: String) {
  listEpmMasterRoleTypes(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, keyword: $keyword}
  ) {
    items {
      id
      name
      enabled
      sortOrder
      createdAt
      updatedAt
      usageStats {
        employeeAllocationCount
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListEpmMasterRoleTypesQuery__
 *
 * To run a query within a React component, call `useListEpmMasterRoleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEpmMasterRoleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEpmMasterRoleTypesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useListEpmMasterRoleTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>(
    ListEpmMasterRoleTypesDocument,
    options,
  );
}
export function useListEpmMasterRoleTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>(
    ListEpmMasterRoleTypesDocument,
    options,
  );
}
// @ts-expect-error
export function useListEpmMasterRoleTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>;
export function useListEpmMasterRoleTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListEpmMasterRoleTypesQuery | undefined, ListEpmMasterRoleTypesQueryVariables>;
export function useListEpmMasterRoleTypesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEpmMasterRoleTypesQuery, ListEpmMasterRoleTypesQueryVariables>(
    ListEpmMasterRoleTypesDocument,
    options,
  );
}
export type ListEpmMasterRoleTypesQueryHookResult = ReturnType<typeof useListEpmMasterRoleTypesQuery>;
export type ListEpmMasterRoleTypesLazyQueryHookResult = ReturnType<typeof useListEpmMasterRoleTypesLazyQuery>;
export type ListEpmMasterRoleTypesSuspenseQueryHookResult = ReturnType<typeof useListEpmMasterRoleTypesSuspenseQuery>;
